export const remapStore = <S>(s: S) => s;
